

export const baseURL= 
  "https://admin.houseofdhanushdhari.com/api/" 
 


export const auth={
   login: baseURL+"banquet/login",
   register:baseURL+'banquet/register',
   getProfile:baseURL+'banquet/profile',
  
}


export const property={
   getProperty:baseURL+'banquet-property',
   getMenu:baseURL+'banquet-menu',
   // sendEnquiry:baseURL+'real-estate-property-enquiry',
   orderProperty:baseURL+'banquet/create-order',
   verifyPayment:baseURL+'banquet/verify-payment',
   getCalender:baseURL+'banquet-calender',
   getMiscellaneous:baseURL+'banquet-miscellaneous',
   getDecoration:baseURL+'banquet-decoration',
   getPhotography:baseURL+'banquet-photography'
}

